import { useEffect, useState } from "react";
import { FaTrash } from "../../../../assets/icons/vander";
import { useShiftProcedureStore, useForm } from "../../../../hooks";
import { InputForm, SelectForm } from "../../../ui";

const formValidations = {};

export const ShiftProcedureFilterForm = () => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    doctorsSelect,
    procedureTypes,
    params,
    shiftProcedures,

    // Methods
    getDoctorsBySelect,
    startShiftProcedureFilter,
    startResetParams,
  } = useShiftProcedureStore();

  // States ------------------------------------------------//
  const [formData, setFormData] = useState(params);

  // Formulario --------------------------------------------//
  const { formState, onInputChange } = useForm(formData, formValidations);

  // Funciones ---------------------------------------------//
  const onSubmit = () => {
    startShiftProcedureFilter(formState);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (doctorsSelect.data.length === 0) {
      getDoctorsBySelect();
    }
  }, [doctorsSelect.data, getDoctorsBySelect]);

  useEffect(() => {
    setFormData(params);
  }, [params]);

  return (
    <div className="card">
      <div className="card-header border-top border-2 fw-bold">Filtros</div>
      <div className="card-body">
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-4">
              <SelectForm
                label={"Doctor"}
                sublabel={"Campo opcional"}
                options={doctorsSelect.data}
                labelKey={"name"}
                name={"doctorId"}
                value={formState.doctorId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <InputForm
                label={"Documento paciente"}
                sublabel={"Campo opcional"}
                type={"text"}
                placeholder={"Documento paciente"}
                name={"patientDocument"}
                value={formState.patientDocument}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <SelectForm
                label={"Tipo de procedimiento"}
                sublabel={"Campo opcional"}
                options={procedureTypes}
                labelKey={"label"}
                name={"procedureType"}
                value={formState.procedureType}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {"¿Con complicaciones?"} <span className="text-danger"></span>
                <span className="text-danger" style={{ fontSize: "10px" }}>
                  {"Campo opcional"}
                </span>
              </label>
              <div className="custom-control custom-radio custom-control-inline">
                <div className="form-check mb-0">
                  <input
                    id="hasComplications-yes"
                    className="form-check-input me-2"
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                    }}
                    readOnly
                    type="radio"
                    name={`hasComplications`}
                    value={"true"}
                    checked={formState.hasComplications === "true"}
                    onChange={onInputChange}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: "18px" }}
                    htmlFor="hasComplications-yes"
                  >
                    Si
                  </label>
                </div>
                <div className="form-check mb-0">
                  <input
                    id="hasComplications-no"
                    className="form-check-input me-2"
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                    }}
                    readOnly
                    type="radio"
                    name={`hasComplications`}
                    value={"false"}
                    checked={formState.hasComplications === "false"}
                    onChange={onInputChange}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: "18px" }}
                    htmlFor="hasComplications-no"
                  >
                    No
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <InputForm
                label={"Fecha incial"}
                sublabel={"Campo opcional"}
                type={"date"}
                placeholder={"Fecha"}
                name={"startProcedureTime"}
                value={formState.startProcedureTime}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <InputForm
                label={"Fecha final"}
                sublabel={"Campo opcional"}
                type={"date"}
                placeholder={"Fecha"}
                name={"endProcedureTime"}
                value={formState.endProcedureTime}
                onInputChange={onInputChange}
              />
            </div>
          </>
          <div className="col-md-12">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => onSubmit()}
              disabled={shiftProcedures.isLoading}
            >
              Filtrar
            </button>
            <button
              className="btn btn-icon btn-pills btn-warning ms-2"
              onClick={() => startResetParams()}
              disabled={shiftProcedures.isLoading}
            >
              <FaTrash className="icons" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
